function hasMoreLinesThan(element, numberOfLinesLimit) {
  let totalNumberOfLines = 0;
  for (let i = 0; i < element.childNodes.length; i++) {
    const childElement = element.childNodes[i];
    const lineHeight = parseInt(window.getComputedStyle(childElement).lineHeight);
    const numberOfLines = Math.ceil(childElement.offsetHeight/lineHeight);
    totalNumberOfLines += numberOfLines;
    if (totalNumberOfLines > numberOfLinesLimit) {
      return true;
    }
  }
  return false;
}

function initFooterDescElement () {
  const footerDescElement = document.querySelector('.footer-description');
  if (!footerDescElement) {
    return;
  }

  const footerDescShowMoreButton = document.querySelector('.footer-description__read-more');
  const footerDescShowLessButton = document.querySelector('.footer-description__read-less');
  
  function setFooterDescButtonsVisibility () {
    const isOverflowing = footerDescElement.clientHeight < footerDescElement.scrollHeight;
    if (isOverflowing) {
      footerDescShowLessButton.style.display = "none";
      footerDescShowMoreButton.style.display = "block";
    } else {
      footerDescShowMoreButton.style.display = "none";
      const isMobile = document.body.clientWidth < 750;
      const numberOfLinesLimit = isMobile ? 10 : 13;
      const shouldBeCollapsible = hasMoreLinesThan(footerDescElement.querySelector('.metafield-rich_text_field'), numberOfLinesLimit);
      footerDescShowLessButton.style.display = shouldBeCollapsible ? "block" : "none";
    }
  }
  
  setFooterDescButtonsVisibility();

  footerDescShowMoreButton.addEventListener('click', () => {
    footerDescElement.classList.add("footer-description--show-more");
    setFooterDescButtonsVisibility();
  });
  
  footerDescShowLessButton.addEventListener('click', () => {
    footerDescElement.classList.remove("footer-description--show-more");
    setFooterDescButtonsVisibility();
  });
  
  window.addEventListener('resize', debounce(setFooterDescButtonsVisibility, 500), true);
}

initFooterDescElement();